/**
 * 바텀시트 상태 관리 Composable
 * Pull-to-Refresh와의 충돌 방지를 위해 전역 상태로 바텀시트 열림 여부를 추적
 */
export const useBottomSheet = () => {
  // 전역 상태: 현재 어떤 바텀시트라도 열려있는지 여부
  const isAnyBottomSheetOpen = useState<boolean>('isAnyBottomSheetOpen', () => false)

  /**
   * 바텀시트 열기
   * 글로벌 상태를 true로 설정하여 Pull-to-Refresh 차단
   */
  const openBottomSheet = () => {
    isAnyBottomSheetOpen.value = true
  }

  /**
   * 바텀시트 닫기
   * 글로벌 상태를 false로 설정하여 Pull-to-Refresh 재활성화
   */
  const closeBottomSheet = () => {
    isAnyBottomSheetOpen.value = false
  }

  return {
    isAnyBottomSheetOpen,
    openBottomSheet,
    closeBottomSheet,
  }
}
